import {Component, Input, OnInit} from '@angular/core';
import {TrackingService} from "@services";

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss']
})
export class AuditComponent implements OnInit {

  statusName: any = [];

  @Input() tramiteObject: any;

  constructor(private trackingService: TrackingService) { }
  tableFilter: any[] = [];

  ngOnInit(): void {
    this.seguimiento();
  }

  seguimiento() {
    this.trackingService.getInfoSeguimiento(this.tramiteObject.id).subscribe((values) => {
      this.statusName = values;
    });
  }

}
